


































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import Axios from "../../plugins/http";

@Component
export default class Index extends Vue {
  compressCode: string = "";
  skuCodes: string = "";
  tableData: any[] = [];
  pageNo: number = 1;
  total: number = 1;
  size: number = 100;
  loading: boolean = false;
  visible: boolean = false;
  addSkuCodes: string = "";

  submitLoading:boolean = false;
  created() {
    this.getList();
  }

  handlePageChange(val) {
    this.pageNo = val;
    this.getList();
  }
  getList() {
    this.loading = true;
    Axios.getSecret(`/api/skuCodeCompress/page`, {
      pageNo: this.pageNo,
      compressCode: this.compressCode,
      skuCodes: this.skuCodes,
    }).then(
      ({
        data: {
          data: { records, total, size },
          status,
          msg,
        },
      }) => {
        this.loading = false;
        if (status === 200) {
          this.tableData = records;
          this.total = total;
          this.size = size;
        } else {
          this.$message(msg);
        }
      }
    );
  }
  addRule() {
    this.visible = true;
    this.addSkuCodes = "";
  }
  modify(row) {
    this.$set(row, "isEdit", true);
  }
  submitRule(row) {
    if(this.submitLoading) return;
    let postData: any = {};
    if (!row) {
      postData.skuCodes = this.addSkuCodes;
      this.submitData(postData, null);
    } else {
      postData.id = row.id;
      postData.skuCodes = row.skuCodes;
      postData.randomCount = row.randomCount;
      this.$confirm("确认修改吗? ", "", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
        customClass: "accountConfirm",
      }).then(() => {
        this.submitData(postData, row);
      });
    }
  }

  submitData(postData, row) {
    console.log(this.submitLoading)
    this.submitLoading = true;
    Axios.postByJson("/api/skuCodeCompress/save", postData)
      .then((res) => {
        setTimeout(()=>{
          this.submitLoading = false;
        },1000)
        
        if (res.data.status === 200) {
          this.$message({
            type: "success",
            message: `保存成功`,
          });
          if (row) {
            this.$set(row, "isEdit", false);
          }
          this.visible = false;
          this.getList();
        } else {
          this.$message(res.data.msg);
        }
      })
      .catch(() => {
        this.$message({
          type: "info",
          message: "已取消",
        });
      });
  }

  deleteRule(id) {
    this.$confirm("确认删除吗? 删除后压缩规则将失效", "", {
      confirmButtonText: "确认",
      cancelButtonText: "取消",
      type: "warning",
      customClass: "accountConfirm",
    }).then(() => {
      Axios.postByJson("/api/skuCodeCompress/delete", { id })
        .then((res) => {
          if (res.data.status === 200) {
            this.$message({
              type: "success",
              message: `删除成功`,
            });
            this.getList();
          } else {
            this.$message(res.data.msg);
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    });
  }

  copyData(row) {
    let input: any = document.getElementById("copy");
    let text = row.skuCodes;
    input.value = text; // 修改文本框的内容
    input.select(); // 选中文本
    document.execCommand("copy"); // 执行浏览器复制命令
    this.$message("已复制");
  }

  onChangeSku(e, data) {
    data.randomCount = e.split("+").filter((item) => item).length;
  }
}
